module.exports = __webpack_public_path__ + "static/media/en-data-roaming-other_7.d83eb960.png";